import { render, staticRenderFns } from "./AdditionalMessageInfo.vue?vue&type=template&id=09177964&scoped=true&"
import script from "./AdditionalMessageInfo.vue?vue&type=script&lang=js&"
export * from "./AdditionalMessageInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalMessageInfo.vue?vue&type=style&index=0&id=09177964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09177964",
  null
  
)

export default component.exports